module.exports = __webpack_public_path__ + "img/instagram.d3652e46.svg";